const {internalGaps} = require('./timesheetDayPresentation');

// Shared by filters, visible rows and print; immutable snapshots bound cache lifetime.
const snapshots = new WeakMap();
function groupGaps(grid, group, sourceIndex) {
    if (!snapshots.has(grid)) snapshots.set(grid, new WeakMap());
    const groups = snapshots.get(grid);
    if (!groups.has(group)) {
        const sources = sourceIndex || new Map((grid.sources || []).map(source => [source.timesheet_id, source]));
        groups.set(group, internalGaps(grid.dates, grid.dates.filter(date => group.days[date] && group.days[date].explicit),
            group.rows.every(row => row.available !== false && row.days && sources.has(row.source_id))));
    }
    return groups.get(group);
}

module.exports = {groupGaps};
